import React, { useCallback, useContext, useRef } from 'react'
import { makeStyles } from '@material-ui/core'
import useGroomingVisit from '../../../../../hooks/useGroomingVisit'
import SectionFormContainer from '../../../components/SectionFormContainer'
import EmailImage from '../../../../../assets/email-image.png'
import { MainButton } from '../../../../Button/MainButton'
import { CloudUpload } from '@material-ui/icons'
import FileReferenceIndicator from '../../../components/FileReferenceIndicator'
import GroomingAppointmentWizardContext from '../GroomingAppointmentWizardContext'
import { purple } from '../../../../../utils/colors'

const useStyles = makeStyles(() => ({
	root: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		paddingTop: '1rem',
		gap: '1rem',
		alignItems: 'center',
		justifyContent: 'center'
	},
	imageContainer: {
		height: '138px',
		padding: '1rem 0',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	image: { height: '100%' },
	sectionFormContainer: { width: '80%', flex: 1 },
	actionSection: { display: 'flex', flexDirection: 'column', width: '90%' },
	buttonsContainer: {
		display: 'flex',
		gap: '1rem',
		margin: '1.5rem 0',
		'& .MuiButton-root': {
			'& .MuiButton-label': {
				'& .MuiButton-startIcon': {
					'& svg': { fill: purple[500] }
				}
			}
		}
	}
}))

// Since this needs to handle 2 properties in the context, we
// can't rely on the visit_attr from the config for this step
const PHOTO_SUBMISSION_ATTRIBUTES = {
	reference_photo_url: 'reference_photo_url',
	reference_photo_email_sent: 'reference_photo_email_sent',
	reference_photo_file: 'reference_photo_file'
}

const PhotoSubmission = (props) => {
	const classes = useStyles()
	const {
		wizardContextProvider: { grooming_appointment, setWizardAttributeAndValues }
	} = useContext(GroomingAppointmentWizardContext)
	const { visit_attr, subtext = '', title = '' } = props
	const { sendReferenceImageRequest } = useGroomingVisit()
	const uploadInputRef = useRef()

	const handleRemoveCurrentFileReference = useCallback(() => {
		const newValues = { ...grooming_appointment }
		newValues[PHOTO_SUBMISSION_ATTRIBUTES.reference_photo_file] = null
		setWizardAttributeAndValues(newValues)
		if (uploadInputRef) {
			uploadInputRef.value = null
		}
	}, [grooming_appointment, setWizardAttributeAndValues, uploadInputRef])

	const handleRemovePhotoUrlReference = useCallback(() => {
		const newValues = { ...grooming_appointment }
		newValues[PHOTO_SUBMISSION_ATTRIBUTES.reference_photo_url] = ''
		setWizardAttributeAndValues(newValues)
	}, [grooming_appointment, setWizardAttributeAndValues])

	const handlePhotoUpload = useCallback(
		async (e) => {
			if (e.target.files && e.target.files.length > 0) {
				const file = e.target.files[0]
				const newValues = { ...grooming_appointment }
				newValues[PHOTO_SUBMISSION_ATTRIBUTES.reference_photo_file] = file
				setWizardAttributeAndValues(newValues)
			}
		},
		[grooming_appointment, setWizardAttributeAndValues]
	)

	const handlePhotoUploadSelected = useCallback(() => {
		if (uploadInputRef.current) {
			uploadInputRef.current.click()
		}
	}, [uploadInputRef])

	const handleSendEmail = useCallback(async () => {
		try {
			// @TODO
			const { _id: visitId } = grooming_appointment
			const data = await sendReferenceImageRequest({ visitId })
			// just alert as this isn't ready yet.
			alert(data.data.errors[0])
		} catch (e) {
			console.log(e)
		}
	}, [grooming_appointment, setWizardAttributeAndValues, visit_attr, sendReferenceImageRequest])

	return (
		<div className={classes.root}>
			<div className={classes.imageContainer}>
				<img className={classes.image} src={EmailImage} />
			</div>
			<div className={classes.sectionFormContainer}>
				<SectionFormContainer title={title} subtext={subtext} titleStyles={{ paddingTop: 0 }}>
					<div className={classes.actionSection}>
						<div className={classes.buttonsContainer}>
							<MainButton
								disabled={true}
								label={'Send photo intake email'}
								onClick={handleSendEmail}
							/>
							<MainButton
								label={'Upload from computer'}
								startIcon={<CloudUpload />}
								onClick={handlePhotoUploadSelected}
							/>
						</div>
						{grooming_appointment[PHOTO_SUBMISSION_ATTRIBUTES.reference_photo_email_sent] === true ? (
							<div>photo sent, please check with client</div>
						) : null}
						{grooming_appointment[PHOTO_SUBMISSION_ATTRIBUTES.reference_photo_url] > '' &&
						!grooming_appointment[PHOTO_SUBMISSION_ATTRIBUTES.reference_photo_file] ? (
							<FileReferenceIndicator
								fileUrl={grooming_appointment[PHOTO_SUBMISSION_ATTRIBUTES.reference_photo_url]}
							/>
						) : null}
						{grooming_appointment[PHOTO_SUBMISSION_ATTRIBUTES.reference_photo_file] ? (
							<FileReferenceIndicator
								fileName={
									grooming_appointment[PHOTO_SUBMISSION_ATTRIBUTES.reference_photo_file].name
								}
								fileSize={
									grooming_appointment[PHOTO_SUBMISSION_ATTRIBUTES.reference_photo_file].size
								}
								onDelete={handleRemoveCurrentFileReference}
							/>
						) : null}
					</div>

					<div>
						<input
							hidden
							accept="image/*, application/pdf"
							className={classes.input}
							type="file"
							id="booger"
							ref={uploadInputRef}
							onChange={(e) => {
								handlePhotoUpload(e)
							}}
						/>
					</div>
				</SectionFormContainer>
			</div>
		</div>
	)
}

export default PhotoSubmission
